
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat/[id]",
      function () {
        return require("private-next-pages/chat/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat/[id]"])
      });
    }
  